// extracted by mini-css-extract-plugin
export default {"wrapper":"xJUtYNaK","container":"SovZdb0K","banner":"UFAYirh_","defaultPlaceholder":"kZhGi9pC","desktop":"desktop","pop-up_main_container":"pop-up_main_container","mobile":"mobile"};